module.exports = __webpack_public_path__ + "img/eye_on_dark.a69f62c3.svg";